export default __webpack_public_path__ + "static/media/book_club.70732cb1.jpeg";